import React from 'react';
import { styled } from '@mui/material';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { Card, Dropdown, Icon, IconButton, Stack, Text } from 'shell/components';

const ProjectCard = ({ handleProjectCardDropdown, role, project, numGroups, selectProject }) => {
    const history = useHistory();

    const handleClickProject = () => {
        if (process.env.REACT_APP_AUTH === 'LTI') {
            history.push(role === 'instructor' ? '/overview' : '/dashboard');
        } else {
            selectProject();
        }
    };

    return (
        <Card onClick={handleClickProject}>
            <Stack>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'p2'}>Project 1</Text>
                    {role === 'instructor' && (
                        <Dropdown
                            id={'project-card-dropdown'}
                            options={[
                                { key: 'edit-project-details', value: 'Edit project details' },
                                { key: 'clone-contents', value: 'Import or export project content' },
                            ]}
                            rootComponent={
                                <IconButton
                                    aria-label={'more options'}
                                    kind={'moreHorizontal'}
                                    size={'small'}
                                    variant={'square'}
                                />
                            }
                            onSelect={handleProjectCardDropdown}
                        />
                    )}
                </Stack>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        {project.title}
                    </Text>
                </Stack>
                <CustomText color={'light'} variant={'p2'}>
                    {project.start_on && project.end_on
                        ? `${moment(project.start_on).format('MMM D[,] YYYY')} - ${moment(project.end_on).format(
                              'MMM D[,] YYYY'
                          )}`
                        : ''}
                </CustomText>
                <CustomStack alignItems={'center'} direction={'row'} spacing={2}>
                    <Icon sx={{ fontSize: '1rem' }} kind={'teams'} />
                    <Text color={'inherit'} variant={'p2'}>
                        {numGroups} Teams
                    </Text>
                </CustomStack>
            </Stack>
        </Card>
    );
};

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 5),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

export default ProjectCard;
